import Container from '@mui/material/Container';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';
import { CalendarView } from '../../features/schedules/CalendarView';

const CalendarPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.SCHEDULES}>
    <Container
      sx={{
        px: {
          xs: 0, lg: 2, md: 2, sm: 2,
        },
      }}
      maxWidth={false}
    >
      <CalendarView />
    </Container>
  </PageHelmet>
);

export default CalendarPage;
